import { z } from 'zod/v3';
import { zIsoDate } from './zIsoDate';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './zValidPeriod.translations.json';

const { addTranslations, t } = i18nNsFactory('valid-period');
addTranslations(translations);

export const zValidPeriod = () =>
  z.tuple([zIsoDate().nullable(), zIsoDate().nullable()]);

export const zValidPeriodWithFromRequired = () =>
  z.tuple([zIsoDate(() => t('from-is-required')), zIsoDate().nullable()]);

export const zValidPeriodWithToRequired = () =>
  z.tuple([zIsoDate().nullable(), zIsoDate(() => t('to-is-required'))]);

export const zValidPeriodWithBothRequired = () =>
  z.tuple([
    zIsoDate(() => t('from-is-required')),
    zIsoDate(() => t('to-is-required')),
  ]);
